import * as types from './mutation-types'
let defaultObject = () => ({
  data: {
  }
})

export default {
  [types.SET_TAG] (state, payload) {
    if (payload === null) {
      payload = defaultObject()
    }
    state.tag = payload
  },
  [types.SET_TAGS] (state, payload) {
    state.tags = payload.data
    state.pagination = payload.meta.pagination
  }
}
